import { Link } from "react-router-dom";
import { technologyServices } from "./serviceConfig";

export default function TechnologyNavigation({ withTopSpacing = false }) {
  return (
    <section
      className={`
        sticky
        top-0
        z-30
        border-y
        border-neutral-200
        bg-white/95
        backdrop-blur-xl
        ${withTopSpacing ? "mt-[100px]" : ""}
      `}
    >
      <div
        className="
          mx-auto
          flex
          max-w-7xl
          gap-2
          overflow-x-auto
          px-5
          py-4
          sm:px-8
          lg:px-10
        "
      >
        {technologyServices.map((service) => (
          <Link
            key={service.slug}
            to={service.route}
            className="
              shrink-0
              rounded-full
              border
              border-neutral-200
              bg-[#f7f7f7]
              px-4
              py-2
              text-xs
              font-semibold
              text-neutral-600
              transition
              hover:border-[#55aef3]
              hover:bg-blue-50
              hover:text-[#3899e4]
            "
          >
            {service.name}
          </Link>
        ))}
      </div>
    </section>
  );
}
